export default __webpack_public_path__ + "dac857eaeda937793a54db5301b14e46.png";